/* ══════════════════════════════════════════
   MOCK DATA — PORTALE ASSISTITO (PAZIENTE)
   ══════════════════════════════════════════ */

export const profiloPaziente = {
  id: 'paz-1',
  nome: 'Elena',
  cognome: 'Ferrara',
  eta: 78,
  cf: 'FRRLNE48D55H501Z',
  indirizzo: 'Via Giulia 42, Roma',
  telefono: '06 6832 1547',
  avatar: 'EF',
  codicePAI: 'PAI-2026-00042',
  dataAttivazione: '03/02/2026',
  provider: 'Coop. Cuore di San Camillo',
  qrCode: 'ADI-PAZ-078-EF-2026',
};

export const profiliGestiti = [
  { id: 'paz-1', nome: 'Elena Ferrara', relazione: 'Io', avatar: 'EF', attivo: true },
  { id: 'paz-2', nome: 'Giovanni Ferrara', relazione: 'Mio marito', avatar: 'GF', attivo: false },
];

export const prossimaVisita = {
  tipo: 'Visita Infermieristica',
  operatore: 'Infermiere Marco Colombo',
  avatarOperatore: 'MC',
  data: 'Oggi',
  ora: '10:30',
  stato: 'in-arrivo',
  note: 'Rilevazione parametri vitali, medicazione e somministrazione terapia.',
};

export const notifiche = [
  {
    id: 'notif-1',
    tipo: 'promemoria',
    titolo: 'Misura la pressione',
    descrizione: 'Ricordati di misurare la pressione arteriosa prima della visita di oggi.',
    ora: '08:00',
    letta: false,
  },
  {
    id: 'notif-2',
    tipo: 'documento',
    titolo: 'Nuovo referto disponibile',
    descrizione: 'Il referto della spirometria del 15/02 e stato caricato nel tuo fascicolo.',
    ora: '09:15',
    letta: false,
  },
  {
    id: 'notif-3',
    tipo: 'aggiornamento',
    titolo: 'PAI aggiornato',
    descrizione: 'Il tuo piano assistenziale e stato aggiornato dal Case Manager.',
    ora: 'Ieri',
    letta: true,
  },
];

/* ══════ Utility per date relative ══════ */
function getRelativeDate(dayOffset) {
  const d = new Date();
  d.setDate(d.getDate() + dayOffset);
  return d;
}
function formatDDMMYYYY(d) { return `${String(d.getDate()).padStart(2,'0')}/${String(d.getMonth()+1).padStart(2,'0')}/${d.getFullYear()}`; }
function formatGiorno(d) {
  const giorni = ['Domenica','Lunedi','Martedi','Mercoledi','Giovedi','Venerdi','Sabato'];
  const mesi = ['Gennaio','Febbraio','Marzo','Aprile','Maggio','Giugno','Luglio','Agosto','Settembre','Ottobre','Novembre','Dicembre'];
  return `${giorni[d.getDay()]} ${d.getDate()} ${mesi[d.getMonth()]}`;
}

const ieri = getRelativeDate(-1);
const oggi = getRelativeDate(0);
const domani = getRelativeDate(1);
const dopodomani = getRelativeDate(2);
const tratreg = getRelativeDate(3);
const fra5gg = getRelativeDate(5);
const fra7gg = getRelativeDate(7);

export const visiteProgrammate = [
  /* Ieri (passate) */
  { id: 'vis-past-1', tipo: 'Visita Infermieristica', operatore: 'Inf. Marco Colombo', avatar: 'MC', dateObj: ieri, data: formatDDMMYYYY(ieri), ora: '10:30', fascia: 'Mattina, tra le 10:00 e le 12:00', giorno: formatGiorno(ieri), stato: 'conclusa' },
  { id: 'vis-past-2', tipo: 'Fisioterapia Domiciliare', operatore: 'Ft. Laura Marchetti', avatar: 'LM', dateObj: ieri, data: formatDDMMYYYY(ieri), ora: '15:00', fascia: 'Pomeriggio, tra le 14:30 e le 16:00', giorno: formatGiorno(ieri), stato: 'conclusa' },
  /* Oggi */
  { id: 'vis-1', tipo: 'Visita Infermieristica', operatore: 'Inf. Marco Colombo', avatar: 'MC', dateObj: oggi, data: formatDDMMYYYY(oggi), ora: '10:30', fascia: 'Mattina, tra le 10:00 e le 12:00', giorno: formatGiorno(oggi), stato: 'confermata' },
  { id: 'vis-2', tipo: 'Visita OSS', operatore: 'OSS Fabio Conti', avatar: 'FC', dateObj: oggi, data: formatDDMMYYYY(oggi), ora: '08:30', fascia: 'Prima mattina, tra le 08:00 e le 09:30', giorno: formatGiorno(oggi), stato: 'confermata' },
  /* Domani */
  { id: 'vis-3', tipo: 'Fisioterapia Domiciliare', operatore: 'Ft. Laura Marchetti', avatar: 'LM', dateObj: domani, data: formatDDMMYYYY(domani), ora: '11:00', fascia: 'Mattina, tra le 10:30 e le 12:00', giorno: formatGiorno(domani), stato: 'confermata' },
  /* Dopodomani */
  { id: 'vis-4', tipo: 'Teleconsulto Cardiologia', operatore: 'Dr. Marini Roberto', avatar: 'MR', dateObj: dopodomani, data: formatDDMMYYYY(dopodomani), ora: '14:30', fascia: 'Pomeriggio, alle 14:30', giorno: formatGiorno(dopodomani), stato: 'da-confermare' },
  /* Tra 3 giorni */
  { id: 'vis-5', tipo: 'Visita Infermieristica', operatore: 'Inf. Marco Colombo', avatar: 'MC', dateObj: tratreg, data: formatDDMMYYYY(tratreg), ora: '10:30', fascia: 'Mattina, tra le 10:00 e le 12:00', giorno: formatGiorno(tratreg), stato: 'confermata' },
  /* Tra 5 giorni */
  { id: 'vis-6', tipo: 'Fisioterapia Domiciliare', operatore: 'Ft. Laura Marchetti', avatar: 'LM', dateObj: fra5gg, data: formatDDMMYYYY(fra5gg), ora: '11:00', fascia: 'Mattina, tra le 10:30 e le 12:00', giorno: formatGiorno(fra5gg), stato: 'confermata' },
  /* Tra 7 giorni */
  { id: 'vis-7', tipo: 'Visita Infermieristica', operatore: 'Inf. Marco Colombo', avatar: 'MC', dateObj: fra7gg, data: formatDDMMYYYY(fra7gg), ora: '10:30', fascia: 'Mattina, tra le 10:00 e le 12:00', giorno: formatGiorno(fra7gg), stato: 'confermata' },
];

/* ══════ PAI SEMPLIFICATO ══════ */
export const paiPaziente = {
  dataInizio: '03/02/2026',
  dataFine: '20/03/2026',
  stato: 'attivo',
  obiettivoPrincipale: 'Migliorare l\'autonomia nel camminare e gestire la terapia per il diabete a casa, in sicurezza.',
  obiettivi: [
    { id: 'ob-1', testo: 'Riprendere a camminare con il deambulatore in autonomia', icona: 'walk', progresso: 60 },
    { id: 'ob-2', testo: 'Imparare a misurare la glicemia da sola', icona: 'health', progresso: 80 },
    { id: 'ob-3', testo: 'Rinforzare i muscoli delle gambe con gli esercizi', icona: 'muscle', progresso: 45 },
  ],
  equipe: [
    { id: 'eq-1', nome: 'Dr. Amato Luca', ruolo: 'Medico di Famiglia', avatar: 'AL', color: '#3B82F6' },
    { id: 'eq-2', nome: 'Marco Colombo', ruolo: 'Infermiere', avatar: 'MC', color: '#10B981' },
    { id: 'eq-3', nome: 'Laura Marchetti', ruolo: 'Fisioterapista', avatar: 'LM', color: '#F59E0B' },
    { id: 'eq-4', nome: 'Fabio Conti', ruolo: 'OSS', avatar: 'FC', color: '#8B5CF6' },
    { id: 'eq-5', nome: 'Francesca Baldi', ruolo: 'Case Manager', avatar: 'FB', color: '#EF4444' },
  ],
  interventi: [
    { id: 'int-1', testo: '2 visite infermieristiche a settimana', icona: 'nurse', dettaglio: 'Controllo parametri, medicazione, terapia' },
    { id: 'int-2', testo: '2 sedute di fisioterapia a settimana', icona: 'physio', dettaglio: 'Esercizi deambulazione, rinforzo muscolare' },
    { id: 'int-3', testo: '3 visite OSS a settimana', icona: 'oss', dettaglio: 'Igiene personale, supporto quotidiano' },
    { id: 'int-4', testo: '1 teleconsulto con il cardiologo', icona: 'teleconsulto', dettaglio: 'Rivalutazione terapia diuretica (21 Febbraio)' },
  ],
};

/* ══════ TELEMONITORAGGIO ══════ */
export const parametriVitali = [
  {
    id: 'pressione',
    label: 'Pressione',
    unita: 'mmHg',
    valore: '135/82',
    stato: 'giallo',
    ultimaRilevazione: 'Oggi, 08:15',
    storico: [
      { data: '18/02', valore: '135/82' },
      { data: '17/02', valore: '128/78' },
      { data: '16/02', valore: '140/88' },
      { data: '15/02', valore: '132/80' },
    ],
    soglia: 'Normale: <140/90',
    messaggioVerde: 'Tutto ok — I valori sono nella norma',
    messaggioGiallo: 'Attenzione — Valore ai limiti superiori',
    messaggioRosso: 'Fuori norma — Il medico e stato avvisato',
  },
  {
    id: 'spo2',
    label: 'Ossigenazione (SpO2)',
    unita: '%',
    valore: '93',
    stato: 'verde',
    ultimaRilevazione: 'Oggi, 08:15',
    storico: [
      { data: '18/02', valore: '93' },
      { data: '17/02', valore: '92' },
      { data: '16/02', valore: '91' },
      { data: '15/02', valore: '94' },
    ],
    soglia: 'Normale: >92%',
    messaggioVerde: 'Tutto ok — Ossigenazione nella norma',
    messaggioGiallo: 'Attenzione — Ossigenazione bassa',
    messaggioRosso: 'Fuori norma — Il medico e stato avvisato',
  },
  {
    id: 'glicemia',
    label: 'Glicemia',
    unita: 'mg/dL',
    valore: '165',
    stato: 'rosso',
    ultimaRilevazione: 'Oggi, 07:30',
    storico: [
      { data: '18/02', valore: '165' },
      { data: '17/02', valore: '148' },
      { data: '16/02', valore: '155' },
      { data: '15/02', valore: '138' },
    ],
    soglia: 'A digiuno: 70-110',
    messaggioVerde: 'Tutto ok — Glicemia nella norma',
    messaggioGiallo: 'Attenzione — Glicemia elevata',
    messaggioRosso: 'Fuori norma — Il medico e stato avvisato',
  },
  {
    id: 'peso',
    label: 'Peso',
    unita: 'kg',
    valore: '68.5',
    stato: 'verde',
    ultimaRilevazione: 'Ieri, 07:00',
    storico: [
      { data: '17/02', valore: '68.5' },
      { data: '14/02', valore: '68.8' },
      { data: '10/02', valore: '69.2' },
      { data: '07/02', valore: '69.0' },
    ],
    soglia: 'Stabile: +/- 1kg/sett.',
    messaggioVerde: 'Tutto ok — Peso stabile',
    messaggioGiallo: 'Attenzione — Variazione superiore a 1kg',
    messaggioRosso: 'Fuori norma — Il medico e stato avvisato',
  },
];

/* ══════ COMUNICAZIONI & SOS ══════ */
export const chatPaziente = [
  { id: 'cp-1', autore: 'Infermiere Marco', ruolo: 'Infermiere ADI', testo: 'Buongiorno Elena! Come si sente oggi? Ho visto che la pressione era un po alta stamattina.', timestamp: '18/02/2026 09:00', mio: false },
  { id: 'cp-2', autore: 'Elena', ruolo: 'Paziente', testo: 'Buongiorno Marco. Si un po di capogiro stamattina ma adesso sto meglio.', timestamp: '18/02/2026 09:15', mio: true },
  { id: 'cp-3', autore: 'Infermiere Marco', ruolo: 'Infermiere ADI', testo: 'Va bene Elena. Le consiglio di riposare e bere molta acqua. Ci vediamo alle 10:30 per la visita.', timestamp: '18/02/2026 09:20', mio: false },
  { id: 'cp-4', autore: 'Elena', ruolo: 'Paziente', testo: 'Grazie Marco a dopo!', timestamp: '18/02/2026 09:22', mio: true },
  { id: 'cp-5', autore: 'Centrale Operativa', ruolo: 'COT', testo: 'Gentile Sig.ra Ferrara, le confermiamo che il teleconsulto con il Cardiologo e fissato per venerdi 21/02 alle 14:30. Le invieremo un promemoria.', timestamp: '17/02/2026 14:00', mio: false },
];

/* ══════ ARCHIVIO DOCUMENTI FSE ══════ */
export const documentiPaziente = [
  { id: 'pdoc-1', tipo: 'lettera-dimissione', titolo: 'Lettera di Dimissione — Ospedale San Camillo', data: '10/04/2026', struttura: 'UOC Geriatria — PO San Camillo', desc: 'Dimissione dopo ricovero per scompenso cardiaco acuto. Terapia domiciliare prescritta.' },
  { id: 'pdoc-2', tipo: 'referto', titolo: 'Referto Esami del Sangue', data: '02/04/2026', struttura: 'Laboratorio Analisi — ASL Roma 2', desc: 'Emocromo, funzionalita renale, glicemia, profilo lipidico ed elettroliti.' },
  { id: 'pdoc-3', tipo: 'prescrizione', titolo: 'Piano Terapeutico Aggiornato', data: '08/04/2026', struttura: 'MMG — Dr. Amato Luca', desc: 'Aggiornamento terapia farmacologica post-dimissione con nuovi dosaggi.' },
  { id: 'pdoc-4', tipo: 'pai', titolo: 'Il tuo Piano Assistenziale (PAI)', data: '03/02/2026', struttura: 'UVM ADI — ASL Roma 2', desc: 'Piano con infermiere 2/sett, fisioterapista 2/sett, OSS 3/sett per 45 giorni.' },
  { id: 'pdoc-5', tipo: 'referto', titolo: 'Referto Spirometria', data: '15/02/2026', struttura: 'Ambulatorio Pneumologia — ASL Roma 2', desc: 'Valutazione funzionalita respiratoria. FEV1 45% predetto.' },
  { id: 'pdoc-6', tipo: 'certificato', titolo: 'Certificato Esenzione Ticket', data: '10/01/2026', struttura: 'ASL Roma 2', desc: 'Esenzione per patologia cronica codice 013 — Diabete mellito.' },
];

/* ══════ AREA EDUCATIVA ══════ */
export const materialiEducativi = [
  { id: 'edu-1', tipo: 'video', titolo: 'Come misurare correttamente la pressione', desc: 'Video tutorial di 3 minuti con istruzioni passo-passo per l\'automisurazione.', durata: '3:20', categoria: 'Cuore e Pressione' },
  { id: 'edu-2', tipo: 'guida', titolo: 'Alimentazione consigliata per diabetici', desc: 'Guida PDF con consigli pratici su cosa mangiare e cosa evitare ogni giorno.', pagine: 12, categoria: 'Diabete' },
  { id: 'edu-3', tipo: 'video', titolo: 'Esercizi di respirazione per chi ha la BPCO', desc: 'Video con esercizi semplici da fare a casa per migliorare la respirazione.', durata: '5:10', categoria: 'Respirazione' },
  { id: 'edu-4', tipo: 'guida', titolo: 'Guida per il Caregiver: gestire l\'assistenza a casa', desc: 'Manuale pratico con consigli per chi si prende cura di un familiare.', pagine: 24, categoria: 'Caregiver' },
];

export const serviziTerritorio = [
  { id: 'srv-1', titolo: 'Richiedi bonus assistenza regionale', desc: 'Informazioni e moduli per il contributo economico della Regione Lazio.', tipo: 'bonus' },
  { id: 'srv-2', titolo: 'Prenota trasporto sanitario non urgente', desc: 'Servizio gratuito per visite mediche, esami e terapie ambulatoriali.', tipo: 'trasporto' },
  { id: 'srv-3', titolo: 'Contatta il supporto psicologico caregiver', desc: 'Colloqui gratuiti per chi assiste un familiare a domicilio.', tipo: 'psicologia' },
  { id: 'srv-4', titolo: 'Farmacia a domicilio', desc: 'Consegna farmaci gratuita per pazienti in ADI non deambulanti.', tipo: 'farmacia' },
];
